import { createApiMiddleware, wsMiddleware } from 'componentlibrary';
import { applyMiddleware, createStore } from 'redux';
import logger from 'redux-logger';
import { thunk } from 'redux-thunk';
import { isDevelopmentMode } from '../Utils/Utils';
import rootReducer from '../reducers';
import { authDefaultState } from '../reducers/auth';
import { companyDefaultState } from '../reducers/company';
import { contractorCompanyDefaultState } from '../reducers/contractorCompany';
import { microFrontendDefaultState } from '../reducers/microFrontend';
import { physicalLocationDefaultState } from '../reducers/physicalLocation';
import { rolesDefaultState } from '../reducers/roles';

export const initialStore = {
  auth: authDefaultState(),
  company: companyDefaultState(),
  contractorCompany: contractorCompanyDefaultState(),
  physicalLocation: physicalLocationDefaultState(),
  roles: rolesDefaultState(),
  microFrontend: microFrontendDefaultState(),
};

const middlewares = [thunk, createApiMiddleware, wsMiddleware];

if (isDevelopmentMode()) {
  middlewares.push(logger);
}

middlewares.forEach((mw, index) => {
  if (typeof mw !== 'function') {
    middlewares.splice(index, 1);
  }
});

export default createStore(
  rootReducer,
  initialStore,
  applyMiddleware(...middlewares),
);
